// Shared sx styles for tightening row spacing in data tables across v2 tabs

export const tightTableSx = {
  overflowX: 'auto',
  '& > .MuiGrid-container': {
    paddingTop: '4px !important',
    paddingBottom: '4px !important',
    marginBottom: '0 !important',
  },
  '& .MuiGrid-item > .MuiBox-root': {
    paddingTop: '8px !important',
    paddingBottom: '8px !important',
  },
};
